import Splide from "@splidejs/splide";
// import AutoScroll from '@splidejs/splide-extension-auto-scroll';

$(function () {
  if ($(".splide.topMv-slide").length > 0) {
    new Splide(".splide.topMv-slide", {
      type: "fade",
      gap: 0,
      arrows: false,
      interval: 11000,
      speed: 800,
      pagination: false,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: true,
    }).mount();
  }
});

// 1回だけマウントして、幅ごとに設定を自動切り替え
$(function () {
  if ($(".splide.sec11-slide").length > 0) {
    new Splide(".splide.sec11-slide", {
      type: "loop",
      perPage: 3,
      perMove: 1,
      gap: "20px",
      pagination: false,
      arrows: true,

      // 幅で調整
      breakpoints: {
        1280: { perPage: 3, gap: "16px" },
        1024: { perPage: 2.5, gap: "16px" },
        768: { perPage: 1, perMove: 1, gap: "16px" },
        560: { perPage: 1, perMove: 1, gap: "14px" },
      },
    }).mount();
  }
});

$(function () {
  if ($(".splide.sec16-slide").length > 0) {
    new Splide(".splide.sec16-slide", {
      type: "loop",
      perPage: 3,
      perMove: 1,
      gap: "20px",
      pagination: false,
      arrows: true,

      breakpoints: {
        1280: { perPage: 3, gap: "16px" },
        1024: { perPage: 2.5, gap: "16px" },
        768: { perPage: 1, perMove: 1, gap: "16px" },
        560: { perPage: 1, perMove: 1, gap: "14px" },
      },
    }).mount();
  }
});

$(function () {
  if ($(".splide.sec13-slide").length > 0) {
    new Splide(".splide.sec13-slide", {
      type: "loop",
      perPage: 3, // PC
      perMove: 1,
      gap: "20px",
      pagination: false,
      arrows: true,

      // 幅で調整
      breakpoints: {
        1280: { perPage: 3, gap: "16px" },
        1024: { perPage: 2.5, gap: "16px" },
        768: { perPage: 2.2, focus: "center", gap: "16px" },
        560: { perPage: 1, focus: "center", gap: "14px" },
      },
    }).mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if ($("#main-carousel").length > 0 && $("#thumbnail-carousel").length > 0) {
    const mq = window.matchMedia("(max-width: 767px)");
    let main = null;
    let thumbs = null;

    function mountFor(mobile) {
      // いったん全部破棄
      if (main) {
        main.destroy(true);
        main = null;
      }
      if (thumbs) {
        thumbs.destroy(true);
        thumbs = null;
      }

      if (mobile) {
        // SP：メインだけ。矢印＋スワイプ有効
        main = new Splide("#main-carousel", {
          type: "loop",
          perPage: 1,
          arrows: true,
          pagination: false,
          drag: true,
          gap: "16px",
        });
        main.mount();
        // サムネはCSSでも非表示に
        const thumbEl = document.querySelector("#thumbnail-carousel");
        if (thumbEl) thumbEl.style.display = "none";
      } else {
        // PC：メイン＋サムネ同期
        main = new Splide("#main-carousel", {
          type: "fade",
          rewind: true,
          pagination: false,
          arrows: false,
        });
        thumbs = new Splide("#thumbnail-carousel", {
          type: "loop",
          perPage: 5,
          pagination: false,
          isNavigation: true,
          focus: "center",
          gap: "12px",
        });
        thumbs.mount();
        main.mount();
        main.sync(thumbs);
        const thumbEl = document.querySelector("#thumbnail-carousel");
        if (thumbEl) thumbEl.style.display = "";
      }
    }

    // 初回＆画面幅変化で切替
    mountFor(mq.matches);
    mq.addEventListener("change", (e) => mountFor(e.matches));
  }
});
